import type { ProjectEditButtonProps } from "./project-edit-button.type";
import type { ActionButtonProps } from "@/ui/action-button";

import ProjectEdit from "@/features/Projects/ProjectEdit";
import { useAuthorization } from "@/modules/authorization";
import { useSidePanel } from "@/modules/side-panel";
import { ActionButton } from "@/ui/action-button";

export const ProjectEditButton = ({
  project,
  onClick,
  ...buttonProps
}: ProjectEditButtonProps) => {
  const { openSidePanel } = useSidePanel();
  const { canUpdateItem } = useAuthorization();

  const onButtonClick: ActionButtonProps["onClick"] = (e) => {
    openSidePanel({
      title: project.name,
      component: <ProjectEdit projectId={project.id} />,
    });
    onClick?.(e);
  };

  if (!canUpdateItem(project)) return null;

  return (
    <ActionButton action="edit" {...buttonProps} onClick={onButtonClick} />
  );
};
